export default "__VITE_ASSET__D4grx7DP__"